// extracted by mini-css-extract-plugin
module.exports = {"text":"description_text__2RzEr","button":"description_button__3UMXx"};